import React from 'react';

const ToastContainer = ({ toasts }) => (
  <div id="toast-container" data-testid="toast-container">
    {toasts.map(toast => (
      <div key={toast.id} className="toast show" data-testid={`toast-${toast.type}`}>
        <span
          className="toast-icon"
          style={{ color: toast.type === 'error' ? 'var(--red)' : toast.type === 'info' ? 'var(--blue)' : 'var(--green)' }}
        >
          {toast.type === 'error' ? '✕' : toast.type === 'info' ? 'ℹ' : '✓'}
        </span>
        <span className="toast-msg">{toast.message}</span>
      </div>
    ))}
  </div>
);

export default ToastContainer;
